<template>
    <div>
        <input
            type="text"
            :name="name"
            :class="'form-input active-email ' + elementClass"
            :placeholder="placeholder"
            v-model="email"
            :autocomplete="autocomplete"
            inputmode="email"
            readonly
            ref="email"
            @focus="activate('email')"
            @touchstart="activate('email')"
        />
        <div
            class="mt-2 text-xs space-y-2"
            v-if="isPopulated && activeValidation"
        >
            <div v-show="isUnique" class="text-emerald-500">
                <i class="fal fa-check mr-2"></i>Email address not in use
            </div>
            <div v-show="!isUnique" class="text-red-500">
                <i class="fal fa-times mr-2"></i>That email address is already
                in use. If you have previously registered then proceed to login.
            </div>
            <div v-show="isValid" class="text-emerald-500">
                <i class="fal fa-check mr-2"></i>Is a valid email format
            </div>
            <div v-show="!isValid" class="text-red-500">
                <i class="fal fa-times mr-2"></i>Email format is invalid
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        email: "",
        isUnique: false,
        isValid: false,
    };
}
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        elementClass: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        value: {
            type: String,
            required: false,
            default: "",
        },
        activeValidation: {
            type: Boolean,
            required: true,
            default: false,
        },
        autocomplete: {
            type: String,
            required: false,
            default: "nope",
        },
    },
    data() {
        return initialState();
    },
    mounted() {
        this.email = this.value;
    },
    watch: {
        email() {
            if (this.activeValidation) this.checkEmail();
        },
    },
    methods: {
        checkEmail() {
            return this.$store
                .dispatch("checkEmail", {
                    email: this.email,
                    not_user_id: this.notUserId,
                })
                .then((res) => {
                    this.isUnique = res.unique;
                    this.isValid = res.valid;
                });
        },
        activate(ref) {
            this.$refs[ref].removeAttribute("readonly");
        },
    },
    computed: {
        isPopulated() {
            return this.email.length > 0 ? true : false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
